import { Loading, useTranslation } from "@opendash/core";
import {
  WidgetConfigError,
  createWidgetComponent,
} from "@opendash/plugin-monitoring";

import {
  DataItemDimensionValueInterface,
  DataItemInterface,
  useDataService,
} from "@opendash/plugin-timeseries";
import * as turf from "@turf/turf";
import { Col, List, Row } from "antd";
import dayjs from "dayjs";
import * as L from "leaflet";
import * as React from "react";
import styled from "styled-components";
import { getFeatureCollections } from "../../components/GeographySelector";
import { GeograhpySelectionType } from "../../types";

const BarDiv = styled.div<{ barWidth: string }>`
  div.ant-slider-rail {
    width: ${(props) => props.barWidth};
  }
`;
type DistrictCount = Record<
  string,
  {
    geometry: any;
    count: number;
    id?: string;
    bb: { minLat: number; maxLat: number; minLon: number; maxLon: number };
  }
>;
let exportedData = {} as DistrictCount;
const districtData = () => {
  return Object.values(exportedData);
};

const x = createWidgetComponent<GeograhpySelectionType>(
  ({ config, ...context }) => {
    const t = useTranslation();

    const { width, height } = context.useContainerSize();
    const barWidth = width < 600 ? "5px" : "15px";
    const DataService = useDataService();
    const [maxCount, setMaxCount] = React.useState(0);
    const [cFocusFeature, setCFocusFeature] = React.useState<string>(null);
    const [data, setData] = React.useState<
      [DataItemInterface, number, DataItemDimensionValueInterface[]][]
    >([]);

    const [cdistrictCounts, setCDistictCounts] = React.useState<DistrictCount>(
      {}
    );

    const onEachFeature = (feature, layer) => {
      //bind click
      /*
    let [lng, lat] = turf.getCoord(turf.center(feature));

    let icon = L.divIcon({
      html: "<p style='background-color:transparent'>0</p>",
    });
    L.marker([lat, lng], { icon }).addTo(map.current);
*/
      // layer.bindTooltip(() => {
      //   console.log(cdistrictCounts, feature, layer);
      //   return "" + (cdistrictCounts?.[feature.properties["name"]]?.count || 0);
      // });
      layer.on({
        click: (e) => {
          //setCurrentDistrict(feature);
        },
      });
    };
    //const DataService = useDataService();

    const items = context.useItemDimensionConfig();
    context.setName(
      t("miaas:widgets.mapDistrict.ui.label") +
        items[0][0].source +
        "-" +
        items[0][0].name
    );

    //const history = context.useFetchDimensionValues();

    const fetchConfig = context.useFetchConfig();
    const init = async () => {
      setCDistictCounts({});
      const itemConf = config._dimensions;

      let startHelper;
      if (fetchConfig.historyType === "relative") {
        startHelper = dayjs()
          .subtract(fetchConfig.value, fetchConfig.unit)
          .valueOf();
      }

      const start =
        fetchConfig.historyType === "absolute"
          ? fetchConfig.start
          : startHelper;

      const end =
        fetchConfig.historyType === "absolute"
          ? fetchConfig.end
          : dayjs().valueOf();

      const items = [];
      for (const itemCandidate of itemConf) {
        const [source, id, dim] = itemCandidate;
        const item = await DataService.get(source, id);
        const pipe = {
          stages: [
            {
              action: start ? "historical" : "live",
              params: {
                start,
                end,
                source,
                id,
                amount: 1,
                dimension: dim,
                mode: "sample",
                maxValues: Math.min(
                  365,
                  Math.max(Math.floor((end - start) / (1000 * 60 * 60 * 24)), 1)
                ), //daily slots
              },
            },
            {
              action: "de.openinc.opentransformations.GeoTransformer",
              params: {
                operation: "extractcoord",
                dimension: dim,
              },
            },
          ],
        };
        items.push([
          item,
          dim,
          await DataService.fetchValues(item, {
            historyType: "aggregate",
            aggregation: true,
            aggregationPipe: pipe,
          }),
        ]);
      }

      setData(items);
    };

    React.useEffect(() => {
      if (!fetchConfig || !config._dimensions) {
        throw new WidgetConfigError("opendash:error.data.items_min");
      }

      init();
    }, [
      fetchConfig,
      config.districtFromDimension,
      config.districts,
      config.districtsFromZones,
    ]);
    const map = React.useRef(null);
    const layer = React.useRef(null);
    const container = React.useRef(null);
    const featureGroup = React.useRef(null);

    const geoPoints = React.useMemo(() => {
      return data.map(([item, dimension, values]) => {
        return {
          item,
          dimension,
          values: values.map(({ value, date }) => {
            return {
              date,
              value: value.flat(),
            };
          }),
        };
      });
    }, [data]);

    // Karte in div rendern
    React.useEffect(() => {
      if (!container.current) {
        return;
      }
      map.current = L.map(container.current, {
        center: [0, 0],
        zoom: 1,
        //@ts-ignore
        layers: [L.tileLayer(...window.leafletTiles)],
        //@ts-expect-error
        gestureHandling: true,
      });

      map.current.scrollWheelZoom.enable();
    }, [container]);

    React.useEffect(() => {
      try {
        map.current.invalidateSize();
      } catch (error) {
        // console.error(error);
      }
    }, [map.current, width, height]);
    React.useEffect(() => {
      console.log({ length: Object.keys(cdistrictCounts).length });
      if (Object.keys(cdistrictCounts).length > 0) {
        context.setLoading(false);
      } else {
        context.setLoading(true);
      }
    }, [cdistrictCounts]);

    React.useEffect(() => {
      if (layer.current) {
        map.current.removeLayer(featureGroup.current);
      }

      if (geoPoints.length < 1) {
        return;
      }

      const cTotal = { _total: { count: 0 } };
      context.setLoading(true);
      getFeatureCollections(
        config.type,
        config.type === "json"
          ? config.districts
          : config.type === "dimension"
            ? config.districtFromDimension
            : config.districtsFromZones
      ).then((districtsNew) => {
        const districtCounts: DistrictCount = {};
        districtCounts["_other"] = {
          geometry: {},
          bb: {
            minLat: Number.MAX_SAFE_INTEGER,
            maxLat: Number.MIN_SAFE_INTEGER,
            minLon: Number.MAX_SAFE_INTEGER,
            maxLon: Number.MIN_SAFE_INTEGER,
          },
          id: null,
          count: 0,
        };

        const districts = districtsNew.flatMap((district) => district.features);
        districts.forEach((feature) => {
          if (
            !feature.geometry ||
            feature.geometry.type.toLowerCase() === "point"
          )
            return;
          districtCounts[feature.properties["name"]] = districtCounts[
            feature.properties["name"]
          ] || {
            geometry: {},
            bb: {
              minLat: Number.MAX_SAFE_INTEGER,
              maxLat: Number.MIN_SAFE_INTEGER,
              minLon: Number.MAX_SAFE_INTEGER,
              maxLon: Number.MIN_SAFE_INTEGER,
            },
            id: feature.properties["objectId"],
            count: 0,
          };
          districtCounts[feature.properties["name"]].geometry = feature;
          turf.coordAll(feature).forEach(([lon, lat]) => {
            districtCounts[feature.properties["name"]].bb.maxLat = Math.max(
              lat,
              districtCounts[feature.properties["name"]].bb.maxLat
            );
            districtCounts[feature.properties["name"]].bb.minLat = Math.min(
              lat,
              districtCounts[feature.properties["name"]].bb.minLat
            );
            districtCounts[feature.properties["name"]].bb.maxLon = Math.max(
              lon,
              districtCounts[feature.properties["name"]].bb.maxLon
            );
            districtCounts[feature.properties["name"]].bb.minLon = Math.min(
              lon,
              districtCounts[feature.properties["name"]].bb.minLon
            );
          });
        });

        featureGroup.current = {};
        const bounds = L.featureGroup();
        let max = Number.MIN_SAFE_INTEGER;
        geoPoints.forEach((point) => {
          point.values.forEach((dateValueItem) => {
            for (let i = 0; i < dateValueItem.value.length; i++) {
              const [lon, lat] = dateValueItem.value[i];
              const cDistrict = Object.values(districtCounts).find(
                (district) => {
                  if (
                    lat > district.bb.maxLat ||
                    lat < district.bb.minLat ||
                    lon > district.bb.maxLon ||
                    lon < district.bb.minLon
                  ) {
                    return false;
                  }
                  return turf.booleanPointInPolygon(
                    turf.point([lon, lat]),
                    district.geometry
                  );
                }
              );
              if (!cDistrict) {
                districtCounts["_other"].count++;
                max = Math.max(max, districtCounts["_other"].count);
              } else {
                cDistrict.count++;
                max = Math.max(max, cDistrict.count);
              }
            }
          });
        });
        Object.keys(districtCounts).forEach((district) => {
          districtCounts[district].count = Math.round(
            districtCounts[district].count / (geoPoints[0].values.length || 1)
          );
        });

        setCDistictCounts(districtCounts);
        exportedData = districtCounts;
        setMaxCount(max / geoPoints[0].values.length);
        const styleFunction = (feature) => {
          if (!districtCounts[feature.properties["name"]]) {
            return {};
          }
          return {
            color: "#0063ac",
            weight: 5,
            fillOpacity:
              districtCounts[feature.properties["name"]].count /
              (max / geoPoints[0].values.length),
          };
        };

        const geoJSONFeature = L.geoJSON(districts, {
          style: styleFunction,
          onEachFeature,
        }).addTo(map.current);
        map.current.fitBounds(geoJSONFeature.getBounds());
      });
      context.setLoading(false);
    }, [map.current, geoPoints, featureGroup]);

    React.useEffect(() => {
      if (map.current) {
        map.current.eachLayer((layer) => {
          if (!layer.feature || !layer.feature.properties) return;
          if (cFocusFeature === "_other") {
            container.current.style.border = "8px solid #333";
          } else {
            container.current.style.border = null;
          }
          if (
            layer.feature &&
            layer.feature.properties.name === cFocusFeature
          ) {
            const style = {
              color: "#333",
              weight: 5,
              fillOpacity: 0.5,
            };
            layer.setStyle(style);
          } else {
            if (cFocusFeature == null) {
              if (cdistrictCounts[layer.feature.properties.name]) {
                const style = {
                  color: "#0063ac",
                  weight: 5,
                  fillOpacity:
                    cdistrictCounts[layer.feature.properties.name].count /
                    maxCount,
                };
                layer.setStyle(style);
              }
            } else {
              const style = {
                color: "#0063ac",
                weight: 0,
                fillOpacity: 0,
              };
              layer.setStyle(style);
            }
          }
        });
      }
    }, [cFocusFeature]);

    React.useEffect(() => {
      if (map.current) map.current.invalidateSize();
    }, [width, height]);

    return (
      <>
        {(!cdistrictCounts || Object.keys(cdistrictCounts).length === 0) && (
          <div style={{ height, width, display: "absolute", zIndex: 10 }}>
            <Loading message={"..."} />
          </div>
        )}
        <Row style={{ height, width }}>
          <Col span={6}>
            <List style={{ padding: 16 }}>
              {Object.keys(cdistrictCounts).map((district, idx) => {
                if (district === "_other") return null;
                return (
                  <List.Item
                    key={district}
                    onMouseEnter={() => {
                      setCFocusFeature(district);
                    }}
                    onMouseLeave={() => {
                      setCFocusFeature(null);
                    }}
                  >
                    <List.Item.Meta
                      title={district === "_other" ? "Sonstige" : district}
                      description={`${cdistrictCounts[district].count} Fahrzeuge`}
                    />
                  </List.Item>
                );
              })}
            </List>
          </Col>
          <Col span={18}>
            <div ref={container} style={{ height: "100%", width: "100%" }} />
          </Col>
        </Row>
      </>
    );
  }
);
export default x;
export { districtData };
